<template>
	<div class="chart__content">
		<ve-pie :data="chartData" :extend="chartExtend"></ve-pie>
		<div class="content__percent__title">
			<img src="/static/images/congratulation/studying.png" alt="studying"/>
			<span>{{ percentage }}</span>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		passExam: {
			type: Number,
			default: 0,
		},
		failExam: {
			type: Number,
			default: 0,
		},
		notDoneExam: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			chartData: {
				columns: ["title", "percent"],
				rows: [
					{ title: this.$t('curriculumExam.passExam'), percent: this.passExam },
					{ title: this.$t('curriculumExam.doNotExam'), percent: this.notDoneExam },
					{ title: this.$t('curriculumExam.failExam'), percent: this.failExam },
				],
			},
			chartExtend: {
				legend: {
					bottom: "5%",
					left: "center",
				},
				series: {
					radius: ["30%", "38%"],
					center: ["50%", "48%"],
					color: ["#2ed573", "#a5b1c2", "#ff4d4d"],
				},
			},
		};
	},
	computed: {
		percentage() {
			let sum = this.chartData.rows[0].percent + this.chartData.rows[1].percent + this.chartData.rows[2].percent;
			let percent = ((this.chartData.rows[0].percent / sum) * 100).toFixed(2);
			return `${percent} %`;
		},
	},
};
</script>
<style scoped>
.chart__content {
	position: relative;
}
.content__percent__title {
	position: absolute;
	top: 48%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	row-gap: 5px;
}
.content__percent__title img {
	width: 50px;
	height: 50px;
	margin: 0 auto;
}
.content__percent__title span {
	font-size: 16px;
	font-weight: 700;
	text-transform: uppercase;
	background-image: linear-gradient(
		-225deg,
		#20bf6b 0%,
		#2ed573 29%,
		#ced6e0 67%,
		#20bf6b 100%
	);
	background-size: auto auto;
	background-clip: border-box;
	background-size: 200% auto;
	color: #fff;
	background-clip: text;
	text-fill-color: transparent;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	animation: textClip 2s linear infinite;
	display: inline-block;
}
@keyframes textClip {
	to {
		background-position: 200% center;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/curriculum/chartCurriculumExam.vue